import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import tourImage from "./lanka_logo.png";
import { useTranslation } from "./hooks/useTranslation";
import LanguageSelector from "./components/LanguageSelector";

const Navbar = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLinkClick = () => {
    setMobileMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav className={`navbar ${isScrolled ? "scrolled" : ""}`}>
      <div className="container nav-container">
        <Link to="/" className="logo" onClick={handleLinkClick}>
          <img src={tourImage} alt={t.companyName} />
          <span>{t.companyName}</span>
        </Link>
        
        <button
          className="mobile-menu-toggle"
          onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "✕" : "☰"}
        </button>

        <ul className={`nav-links ${isMobileMenuOpen ? "open" : ""}`}>
          <li><Link to="/home" onClick={handleLinkClick}>{t.home}</Link></li>
          <li><Link to="/about" onClick={handleLinkClick}>{t.about}</Link></li>
          <li><Link to="/testimonials" onClick={handleLinkClick}>{t.testimonials}</Link></li>
          <li><Link to="/contact" onClick={handleLinkClick}>{t.contact}</Link></li>
        </ul>

        <div className="nav-right">
          <LanguageSelector />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
